import React from 'react'

import clsx from 'clsx'

import Icon from '../Icon'
import BaseButton from './components/BaseButton'

import classes from './Button.module.scss'

/** @type {import("./types").default} */
const Button = ({
  className,
  disabled,
  fullWidth,
  href,
  children,
  variant = 'text',
  component,
  color = 'primary',
  size = 'medium',
  icon,
  text,
  ...moreProps
}) => {
  return (
    <BaseButton
      className={clsx(
        'Button',
        classes.root,
        classes[`${size}-${variant}`],
        classes[variant],
        classes[color],
        classes[`${variant}-${color}`],
        !!fullWidth && classes.fullWidth,
        className
      )}
      component={component}
      disabled={disabled}
      href={href}
      {...moreProps}
    >
      {!!icon ? (
        <span className={classes.iconRight}>
          {text}
          {<Icon icon={icon} size="14" />}
        </span>
      ) : (
        children
      )}
    </BaseButton>
  )
}

export default Button
